import React from 'react';
import { Notification, Card } from 'rbx';
import AppService from '../../services/app';
import PdvService from '../../services/pdv';
import Controls from './Controls/Controls';
import useForm from './useForm';
import { unMask } from '../../commons/masks';

const SetAdmForm = ({ setMessage, goToMenu, userApp=false, userPdv=false }) => {
  const user = JSON.parse(sessionStorage.getItem( userApp ? 'app' : 'pdv' ));

  const UserService = userApp ? AppService : PdvService;

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm( {cpf_cnpj: user.cpf_cnpj, password: '', role: 'adm'} );

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton('loading');
    try {
      const response = await UserService.setAdmin({ ...values, cpf_cnpj: unMask(values.cpf_cnpj) });
      await UserService.findByCpf(values.cpf_cnpj);
      setMessage(['success', response.data.message]);
      goToMenu();
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e}`]);
    }
    setStateButton('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>
            { userApp ? 'Definir Usuário como Administrador' : 'Definir PDV como Administrador'}
          </Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Controls.PasswordField 
            label="Senha do ADM"
            name="password"
            value={values.password}
            onChange={handleInputChange}
            focus={true}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToMenu} 
            buttonState={stateButton} 
            buttonName='Definir'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default SetAdmForm;
